<template>
  <v-app id="register" class="secondary lighten-1">
    <div id="register-bg-top" class="primary"></div>
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md5 lg4>

            <v-card class="elevation-1 pa-2">
              <v-card-text class="text-xs-center">
                <img src="@/assets/transpress-logo.png" style="max-height: 30px" class="my-2">
                <h1 class="flex primary--text font-weight-thin">{{ $t('Registration') }}</h1>
              </v-card-text>


              <v-form ref="registerForm" @submit.prevent="onGenerate" v-model="isValid" v-if="step == 1">
                <v-card-text>
                  <h2 class="primary--text mb-2">{{ $t('Creating an account') }}</h2>
                  <p>{{ $t('Enter data for the new account.') }}</p>

                  <p v-if="generated">{{ $t('Registration form submitted successfuly. Please check your email for a confirmation link.') }}</p>
                  <template v-else>
                    <v-text-field v-model="userdata.personalName" :label="$t('Personal name')" :rules="rules.personalName" @input="onFieldInput('personalName')" @blur="onValidateDebounce" class="my-2"></v-text-field>
                    <v-text-field ref="phoneInput" v-model="userdata.phoneNumber"  :label="$t('Phone number')"  :rules="phoneNumberRules" type="tel" :hint="$t('Phone BG hint')"  @input="onFieldInput('phoneNumber')" @blur="onValidateDebounce" class="my-2"></v-text-field>
                    <v-text-field v-model="userdata.emailAddress" :label="$t('Email address')" :rules="rules.emailAddress" @input="onFieldInput('emailAddress')" @blur="onValidateDebounce" class="my-2"></v-text-field>
                    <v-text-field v-model="userdata.partnerCode"  :label="$t('Partner code')"  :rules="rules.partnerCode"  @input="onFieldInput('partnerCode')" @blur="onValidateDebounce" class="my-2"></v-text-field>
                    <v-text-field v-model="userdata.partnerName"  :label="$t('Partner name')"  :rules="rules.partnerName"  @input="onFieldInput('partnerName')" @blur="onValidateDebounce" class="my-2"></v-text-field>
                    <v-text-field v-model="userdata.userName"     :label="$t('Username')"      :rules="rules.userName"     @input="onFieldInput('userName')" @blur="onValidateDebounce" class="my-2"></v-text-field>
                  </template>

                </v-card-text>

                <v-card-actions>
                  <v-btn flat to="/signin" class="text--secondary">
                    <v-icon left>arrow_back</v-icon>{{ $t('Login') }}
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn type="submit" :loading="generating || validating" class="secondary" :disabled="!isValid || generated">
                    <v-icon left>check</v-icon>{{ $t('Register') }}
                  </v-btn>
                </v-card-actions>
              </v-form>


              <v-form ref="passwordForm" @submit.prevent="onPassword"
                v-else-if="step == 2 && progress === 'APPROVED'"
              >
                <v-card-text>
                  <h2 class="primary--text mb-2">{{ $t('Create a password') }}</h2>
                  <p>{{ $t('Now you can create a password. After saving successfuly you will be redirected to the Login screen, where you can sign in with the newly created account.') }} </p>

                  <v-text-field v-model="userpass.password1"
                    :label="$t('Password')"
                    :append-icon="userpass.isShowPassword1 ? 'visibility' : 'visibility_off'"
                    :type="userpass.isShowPassword1 ? 'text' : 'password'"
                    @click:append="userpass.isShowPassword1 = !userpass.isShowPassword1"
                    :hint="$t('Password strength') + ': ' + passwordProgress + '%'"
                    counter loading
                    class="my-2"
                  ><template v-slot:progress>
                      <v-progress-linear :value="passwordProgress" :color="passwordColor" height="5"></v-progress-linear>
                    </template>
                  </v-text-field>

                  <v-text-field v-model="userpass.password2"
                    :label="$t('Re-enter password')"
                    :append-icon="userpass.isShowPassword2 ? 'visibility' : 'visibility_off'"
                    :type="userpass.isShowPassword2 ? 'text' : 'password'"
                    @click:append="userpass.isShowPassword2 = !userpass.isShowPassword2"
                    counter loading
                    class="my-2"
                  ><template v-slot:progress>
                      <v-progress-linear :color="passwordColor" height="2"></v-progress-linear>
                    </template>
                  </v-text-field>
                </v-card-text>

                <v-card-actions>
                  <v-btn flat to="/signin" class="text--secondary">
                    <v-icon left>arrow_back</v-icon>{{ $t('Login') }}
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn type="submit" :loading="passwording" class="secondary" :disabled="!isPasswordValid">
                    <v-icon left>save</v-icon>{{ $t('Save') }}
                  </v-btn>
                </v-card-actions>
              </v-form>


              <v-card-text v-else>
                <div v-if="progress === 'VERIFIED'" style="margin-bottom: -16px">
                  <p>{{ $t('Email confirmed') }}!</p>
                  <p>{{ $t('Your request is being processed. Please check your email.') }} {{ $t('You will receive an approval message.') }}</p>
                </div>

                <span v-else-if="progress === 'DECLINED'">
                  {{ $t('Your request is denied. We are sorry for the inconvenience.') }}
                </span>

                <span v-else>{{ $t('An error occurred when trying to get the progress. Please try again later.') }}</span>
              </v-card-text>

            </v-card>
            <div class="pt-2 text-xs-center caption font-weight-light white--text" v-html="versionInfo"/>
          </v-flex>
        </v-layout>
      </v-container>

      <v-snackbar v-model="isMsg" right top multi-line auto-height :color="msgType" :timeout="msgTimeout">
        <span v-if="msgIsArray">
          <div v-for="line in msgText" :key="line">{{ line }}</div>
        </span>
        <span v-else>{{ msgText }}</span>
        <v-btn icon @click="isMsg = false">
          <v-icon>check</v-icon>
        </v-btn>
      </v-snackbar>
    </v-content>
  </v-app>
</template>

<script>
import { phoneRules } from "../../components/phone";
import { register } from "@/resources";
import { debounce } from "lodash";
import { versionInfo } from "../../components/util.js"

const VALIDATE_DEBOUNCE_TIMEOUT = 1500;

export default {
  props: ["id", "token"],
  data() {
    return {
      isMsg: false,
      msgType: "info",
      msgText: "",
      msgTimeout: 0,
      msgIsArray: false,
      msgCallbackFn: null,

      step: 1,// generate; generated

      validating: false,
      // A validation was requested while another one was in flight; repeat it when done
      validatePending: false,
      generating: false,
      progressing: false,
      passwording: false,

      generated: false,
      passworded: false,
      //progress: "",// VERIFIED; APPROVED; DECLINED. On step==2
      progress: "APPROVED",//@@test

      userdata: {// or profileData and profilePass, or acctData/acctPass
        personalName: "",
        phoneNumber: "",
        emailAddress: "",
        partnerCode: "",
        partnerName: "",
        userName: "",
      },
      userpass: {
        password1: "",
        password2: "",
        isShowPassword1: false,
        isShowPassword2: false,
      },

      rules: {},
      isValid: false,
    }
  },

  computed: {
    phoneNumberRules() {
      return phoneRules(key => this.$t(key), { country: "BG", required: true })
        .concat(this.rules.phoneNumber || []);
    },
    versionInfo() {
      return versionInfo(this, true);
    },
    isPasswordValid() {
      let pass1 = this.userpass.password1,
          pass2 = this.userpass.password2;
      // passwords must match
      return (
        pass1 && !!pass1.trim() &&
        pass1 === pass2
      );
    },
    passwordProgress() {
      let pass = this.userpass.password1;
      let score = 0;
      if (!pass)
        return score;

      // award every unique letter until 5 repetitions
      let letters = new Object();
      for (var i=0; i<pass.length; i++) {
        letters[pass[i]] = (letters[pass[i]] || 0) + 1;
        score += 5.0 / letters[pass[i]];
      }

      // bonus points for mixing it up
      let variations = {
        digits: /\d/.test(pass),
        lower: /[a-z]/.test(pass),
        upper: /[A-Z]/.test(pass),
        nonWords: /\W/.test(pass),
      }

      let variationCount = 0;
      for (var check in variations) {
        variationCount += (variations[check] == true) ? 1 : 0;
      }
      score += (variationCount - 1) * 10;

      return Math.min(100, parseInt(score));
    },
    passwordColor() {
      return ['error', 'warning', 'success'][Math.floor(this.passwordProgress / 40)];
    }
  },

  watch: {
    phoneNumberRules() {
      // Vuetify 1 compares rule functions as objects and can miss changed closures.
      this.$nextTick(() => {
        if (this.$refs.phoneInput) this.$refs.phoneInput.validate();
      });
    },

    isMsg(val) {
      if (!val && this.msgCallbackFn) {
        this.msgCallbackFn();
      }
    }
  },

  methods: {
    /**
     * Validates the registration data on the server.
     *
     * Only one validation request runs at a time. A call made while a request is
     * in flight is not dropped: it is remembered and repeated as soon as the current
     * request completes. A response for data that was changed meanwhile is stale and
     * is ignored, so errors like "missing field" for already filled fields are never shown.
     */
    onValidate() {
      if (this.validating) {
        // Do not lose the call - repeat it after the current request completes
        this.validatePending = true;
        return;
      }
      this.validating = true;
      this.validatePending = false;

      // Snapshot of the sent data, to detect changes made while the request is in flight
      const sent = JSON.stringify(this.userdata);
      const isStale = () => JSON.stringify(this.userdata) !== sent;

      register.validate(JSON.parse(sent)).then(res => {
        console.log("Validate res=", res);
        if (isStale()) {
          // The result does not describe the current data - validate again
          this.validatePending = true;
          return;
        }
        if (res.body && res.body.success)
          this.rules = {};
      }).catch(err => {
        console.log("Validate err=", err);
        if (isStale()) {
          // The errors refer to outdated data (e.g. fields that were empty) - validate again
          this.validatePending = true;
          return;
        }
        if (err.body && err.body.errors)
          this.reRules(err.body.errors);
        else
          this.msg(err.bodyText, "error");

      }).finally(() => {
        this.validating = false;
        // Validate the latest data if it changed or a call was requested meanwhile
        if (this.validatePending)
          this.onValidate();
      });
    },
    onGenerate() {
      if (this.generating || this.validating || !this.$refs.registerForm.validate())
        return;
      this.generating = true;

      register.generate(this.userdata).then(res => {
        console.log("Generate res=", res);
        if (res.body && res.body.success) {
          this.rules = {};
          this.generated = true;
        }
      }).catch(err => {
        console.log("Generate err=", err);
        if (err.body && err.body.errors)
          this.reRules(err.body.errors);
        else
          this.msg(err.bodyText, "error");
      }).finally(() => {
        this.generating = false;
      });
    },
    onProgress() {
      if (this.progressing)
        return;
      this.progressing = true;

      register.progress({
        requestId: this.id,
        token: this.token
      }).then(res => {
        console.log("Progress res=", res);
        if (res.body && res.body.success) {
          this.progress = res.body.status;// VERIFIED, APPROVED, DECLINED
        }
      }).catch(err => {
        console.log("Progress err=", err);
        if (err.body && err.body.errors) {
          if (this.progress === "APPROVED")// password case
            this.reRules(err.body.errors);
          else
            this.msg(err.body.errors, "error");
        }
        else
          this.msg(err.bodyText, "error");
      }).finally(() => {
        this.progressing = false;
      });
    },
    onPassword() {
      if (this.passwording || !this.isPasswordValid)
        return;
      this.passwording = true;

      register.password({
        requestId: this.id,
        token: this.token,
        password: this.userpass.password1
      }).then(res => {
        console.log("Password res=", res);
        if (res.body && res.body.success) {
          this.msg(
            this.$t("Account created successfuly with this password.") +
            this.$t("Now you will be redirected to the Login screen, where you can sign in with the newly created account."),
            "success",
            0,
            () => this.$router.push("/signin")
          );
          this.passworded = true;
        }
      }).catch(err => {
        console.log("Password err=", err);
        if (err.body && err.body.errors)
          this.msg(err.body.errors, "error");
        else
          this.msg(err.bodyText, "error");
      }).finally(() => {
        this.passwording = false;
      });
    },
    reRules(errs) {
      const rules = {};
      Object.keys(this.userdata).forEach(field => {
        const err = errs && errs.find(elem => elem.path === field);
        rules[field] = [ err
          ? () => err.text
          : val => !!val || this.$t("This field is required!")
        ];
      });
      this.rules = rules;
      if (errs)
        setTimeout(() => this.$refs.registerForm.validate(), 500);
    },
    /**
     * Handles typing in a registration field.
     *
     * The server error for the field refers to its previous value, so it is replaced
     * right away with the local "required" rule; then a (debounced) server validation
     * is scheduled for the new value.
     *
     * @param {string} field name of the edited field in userdata
     */
    onFieldInput(field) {
      // $set - the key may not exist yet, keep it reactive
      this.$set(this.rules, field, [ val => !!val || this.$t("This field is required!") ]);
      this.validateDebounced();
    },
    onValidateDebounce(evt) {
      if (evt && evt.type === "blur")
        this.validateDebounced.flush();
      else
        this.validateDebounced();
    },
    errors(errs) {
      let rules = [],
          msgs  = [];
      let fields = this.step == 1 ? this.userdata : this.userpass;
      errs.forEach(err => {
        const matchedfield = Object.keys(fields).find(field => err.path === field);
        if (matchedfield)
          rules.push( err );
        else
          msgs.push( err );
      });

      if (rules.length > 0) {
        rules.forEach(rule => {
          this.rules[rule.path] = [ () => rule.text ];
        });
      }
      if (msgs.length > 0) {
        this.msg( msgs, "error" );
      }
    },
    msg(text, type, timeout, callbackFn) {
      if (!text)
        text = "";
      this.msgIsArray = Array.isArray(text);
      this.msgText = this.msgIsArray
        ? text.map(elem => elem.text)
        : text;

      this.msgType = type || "info";
      this.msgTimeout = 3000;
      if (typeof timeout !== "undefined" && typeof timeout !== "null")
        this.msgTimeout = timeout;
      else if (type === "error")
        this.msgTimeout = 0;

      this.isMsg = true;

      this.msgCallbackFn = callbackFn || null;
    },
  },

  // Lifecycle methods
  created() {
    this.validateDebounced = debounce(this.onValidate, VALIDATE_DEBOUNCE_TIMEOUT);
  },
  mounted() {
    //console.log("Mounted, id=" + this.id + ", token=" + this.token);
    if (this.id && this.token) {
      this.step = 2;
      this.onProgress();
    }
    else {
      this.step = 1;
      this.reRules();
    }
  }

}
</script>

<style scoped>
#register-bg-top {
  height: 50%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
  z-index: 0;
}
button:hover {
  opacity: 0.7;
}
</style>